import { safelyParseDate } from '@/utils/date';

export const normalizeTaskTimestamp = (value) => {
	if (value == null || value === '') {
		return null;
	}

	const date = safelyParseDate(value);
	return date && !Number.isNaN(date.getTime()) ? date.getTime() : null;
};
